import React from "react";
import {Upload} from "antd";
import IFile from "../../../../../model/interface/file/IFile";
import FileUpload from "../../../../app/file-manager/FileUpload";
import {IPropsFilePickerWidget} from "../FilePicker";
import FileActions from "../../../../app/file-manager/FileViews/FileActions";
import {DownloadOutlined} from "@ant-design/icons";

interface IState {
    search?: string,
    directory?: number[],
    loading: boolean,
    saving: boolean,
    visible: boolean
}

interface IProps extends IPropsFilePickerWidget {

}

class Image extends React.Component<IProps, IState> {

    constructor(props: IProps) {
        super(props);
        this.state = {
            loading: false,
            saving: false,
            visible: false
        } as IState
    }

    removeFile = (file: IFile) => {
        this.props.onRemove(file)
    }

    onUpload = (files: IFile[]) => {
        this.props.onChange(this.props.multiple ? [...this.props.fileList, ...files] : files)
        this.setState({visible: false})
    }

    onChoose = (files: IFile[]) => {
        files.length > 0 && this.props.onChange(files)
        this.setState({visible: false})
    }

    showModal = () => {
        this.setState({visible: true})
    }

    render() {
        const {loading, visible} = this.state
        const {
            canChoose,
            canUpload,
            multiple,
            fileList,
            directory,
            canDownload,
            canRemove,
            extensions,
            placeholder
        } = this.props

        return (
            <div>

                <div className={'position-relative'}>
                    {canUpload && (multiple || fileList.length === 0) &&
                        <FileUpload placeholder={placeholder} accept={extensions?.join(',')}
                                    directory={directory}
                                    mode={"image"}
                                    multiple={multiple}
                                    onUpload={this.onUpload}/>}
                </div>
                <Upload showUploadList={{
                    showDownloadIcon: canDownload,
                    showPreviewIcon: false,
                    showRemoveIcon: canRemove,
                    downloadIcon: <DownloadOutlined/>
                }} fileList={fileList.map((f) => ({
                    uid: f.uuid,
                    url: f.thumbnailUrl,
                    name: f.fullName,
                    status: 'done'
                }))} listType={'picture-card'} onRemove={file => {
                    const found = fileList.find(f => f.uuid === file.uid)
                    found && this.removeFile(found)
                }} onDownload={file => {
                    const found = fileList.find(f => f.uuid === file.uid)
                    found && FileActions.download(found)
                }}>

                </Upload>
            </div>
        )
    }
}

export default Image